import React from 'react';
import { UnitAvailabilityTypes } from '../../UnitAvailabilityTypes';
import {
  UNIT_SIZE_FILTER,
  AMENITIES_TYPE_FILTER,
} from '../constants/viewRatesFilterConfig';
export const viewRatesFilterBuilder = (
  unitsData: UnitAvailabilityTypes.TData[]
) => {
  const finalArray: {
    filterList: any[];
  } = {
    filterList: [],
  };
  const amenitiesArray: UnitAvailabilityTypes.TAmenitiesFilter[] = [];
  const unitSizeArray: string[] = [];
  for (const indivUnitType of unitsData) {
    const { tfw: { move_in: moveIn = null } = {}, amenitiesList } =
      indivUnitType || {};
    amenitiesList && amenitiesArray.push(...indivUnitType.amenitiesList);
    moveIn && unitSizeArray.push(indivUnitType.tfw.move_in.group);
  }
  amenitiesArray.map(singleAmenity => {
    finalArray.filterList.push({
      name: singleAmenity.amenity_text,
      type: AMENITIES_TYPE_FILTER,
      value: singleAmenity.amenity_text,
    });
  });
  unitSizeArray.map(indivUnitSize => {
    finalArray.filterList.push({
      name: indivUnitSize,
      type: UNIT_SIZE_FILTER,
      value: indivUnitSize,
    });
  });
  let duplicateRemovedArray = finalArray.filterList.reduce(
    (previousvalue, currentValue) => {
      if (
        !previousvalue.some(
          (obj: any) =>
            obj.value === currentValue.value && obj.type === currentValue.type
        )
      ) {
        previousvalue.push(currentValue);
      }
      return previousvalue;
    },
    []
  );
  duplicateRemovedArray = addSelectAllCheckbox(
    duplicateRemovedArray,
    AMENITIES_TYPE_FILTER,
    'All Amenities'
  );
  duplicateRemovedArray = addSelectAllCheckbox(
    duplicateRemovedArray,
    UNIT_SIZE_FILTER,
    'All Unit Types'
  );
  return duplicateRemovedArray;
};

export const filterAmenities = (
  unitsData: UnitAvailabilityTypes.TData[],
  filterArray: UnitAvailabilityTypes.TFilterObject[]
) => {
  const filteredArray = unitsData.filter(indivUnitData => {
    if (indivUnitData.amenitiesList) {
      const amenitiesArray = indivUnitData.amenitiesList.map(
        indivAmenities => indivAmenities.amenity_text
      );
      return filterArray.every((indivFilter: any) =>
        amenitiesArray.includes(indivFilter)
      );
    }
  });
  return filteredArray;
};

export const addSelectAllCheckbox = (
  inDataArray: any,
  filterType: string,
  filterValue: string
) => {
  const copyDataValue = inDataArray;
  const onlySelectedValueArray = inDataArray.filter(
    (indivArray: any) => indivArray.type === filterType
  );
  if (onlySelectedValueArray.length > 2) {
    copyDataValue.unshift({
      name: 'All',
      type: filterType,
      value: filterValue,
    });
  }
  return copyDataValue;
};

export const filterUnits = (unitsData: any, filterArray: any) => {
  const finalFilteredArray = unitsData.filter((indivUnitData: any) => {
    if (
      indivUnitData.tfw.move_in &&
      indivUnitData.tfw.move_in.group &&
      filterArray.includes(indivUnitData.tfw.move_in.group)
    ) {
      return indivUnitData;
    }
  });
  return finalFilteredArray;
};

export const doesElementExistsFilterInArray = (
  filterArray: any[],
  elementToCheck: any
) => {
  return filterArray.some(
    (singleElement: any) =>
      singleElement.name === elementToCheck.name &&
      singleElement.type === elementToCheck.type
  );
};

export const filterUnitResponseData = (unitsData: any, filterArray: any) => {
  let copyInputsUnitsData: UnitAvailabilityTypes.TData[] = [...unitsData];
  const listOfAmenities = filterArray
    .filter(
      (indivActiveFilter: any) =>
        indivActiveFilter.type === AMENITIES_TYPE_FILTER &&
        indivActiveFilter.name !== 'All'
    )
    .map((selectedFilter: any) => selectedFilter.value);
  if (listOfAmenities && listOfAmenities.length > 0) {
    copyInputsUnitsData = filterAmenities(copyInputsUnitsData, listOfAmenities);
  }
  const listOfUnitsTypes = filterArray
    .filter(
      (indivActiveFilter: any) =>
        indivActiveFilter.type === UNIT_SIZE_FILTER &&
        indivActiveFilter.name !== 'All'
    )
    .map((selectedFilter: any) => selectedFilter.value);
  if (listOfUnitsTypes && listOfUnitsTypes.length > 0) {
    copyInputsUnitsData = filterUnits(copyInputsUnitsData, listOfUnitsTypes);
  }
  return copyInputsUnitsData;
};

export const addFilterToList: UnitAvailabilityTypes.TAddFilterToList = (
  inputFilter,
  activeFilters,
  allFilters,
  updateActiveFilter
) => {
  const activeFiltersOfGivenType = activeFilters.filter(
    indivFilter => indivFilter.type === inputFilter.type
  );
  const allFiltersOfGivenType = allFilters.filter(
    (indivFilter: UnitAvailabilityTypes.TFilterObject) =>
      indivFilter.type === inputFilter.type
  );
  if (allFiltersOfGivenType.length - 2 === activeFiltersOfGivenType.length) {
    updateActiveFilter((prevState: any) => [
      ...prevState,
      inputFilter,
      {
        name: 'All',
        type: inputFilter.type,
        value: `All ${inputFilter.type}`,
      },
    ]);
  } else {
    updateActiveFilter((prevState: any) => [...prevState, inputFilter]);
  }
};

export const onFilterChange = (
  inputIndivFilter: UnitAvailabilityTypes.TFilterObject,
  activeFilters: UnitAvailabilityTypes.TFilterObject[],
  setActiveFilters: React.Dispatch<
    React.SetStateAction<UnitAvailabilityTypes.TFilterObject[]>
  >,
  filter: any
) => {
  const isActiveFilterArrayNotEmpty = activeFilters && activeFilters.length > 0;
  if (inputIndivFilter.name === 'All') {
    handleSelectAllCheckbox(
      inputIndivFilter,
      activeFilters,
      setActiveFilters,
      filter
    );
  } else if (
    isActiveFilterArrayNotEmpty &&
    doesElementExistsFilterInArray(activeFilters, inputIndivFilter)
  ) {
    setActiveFilters(activeFilterArray =>
      activeFilterArray.filter(
        indivFilter =>
          indivFilter.name !== inputIndivFilter.name &&
          indivFilter.name !== 'All'
      )
    );
  } else if (inputIndivFilter.type === 'clearAll') {
    setActiveFilters([]);
  } else {
    addFilterToList(inputIndivFilter, activeFilters, filter, setActiveFilters);
  }
};

export const handleSelectAllCheckbox = (
  inputIndivFilter: UnitAvailabilityTypes.TFilterObject,
  activeFilters: UnitAvailabilityTypes.TFilterObject[],
  setActiveFilters: React.Dispatch<
    React.SetStateAction<UnitAvailabilityTypes.TFilterObject[]>
  >,
  filter: any
) => {
  if (doesElementExistsFilterInArray(activeFilters, inputIndivFilter)) {
    const removedFilterOfGivenType = activeFilters.filter(
      singleActiveFilter => singleActiveFilter.type !== inputIndivFilter.type
    );
    setActiveFilters(removedFilterOfGivenType);
  } else {
    const allFiltersOfType = filter.filter(
      (indivFilter: UnitAvailabilityTypes.TFilterObject) =>
        indivFilter.type === inputIndivFilter.type
    );
    setActiveFilters(prevState => [...prevState, ...allFiltersOfType]);
  }
};

export const addFilterToSavedFilterList = (
  indivUnitType: UnitAvailabilityTypes.TFilterObject,
  savedActiveFilter: any,
  setSavedActiveFilter: React.Dispatch<React.SetStateAction<any>>
) => {
  if (!doesElementExistsFilterInArray(savedActiveFilter, indivUnitType)) {
    setSavedActiveFilter((prevValue: any) => [...prevValue, indivUnitType]);
  } else {
    setSavedActiveFilter((activeSavedFilter: any) =>
      activeSavedFilter.filter(
        (indivFilter: any) => indivFilter.name !== indivUnitType.name
      )
    );
  }
};
